/* import welcome_banner.js */
/* import highlights_risks_feature_section.js */

window.WelcomeApp = function() {
	return {
		state: {
			shouldHideLoading: true
		},
		setState: function(state) {
			for (var key in state) {
				if (!this.state.hasOwnProperty(key)) {
					continue;
				}

				this.state[key] = state[key];
				switch (key) {
					case "shouldHideLoading":
						this.render();
						break;
					default:

				}
			}
		},
		render: function() {
			this.el.find("#welcome-banner").toggleClass("is-show", this.state.shouldHideLoading);
			this.el.find(".welcome-section").toggleClass("is-show", this.state.shouldHideLoading);
			this.el.find("#footer").toggleClass("is-show", this.state.shouldHideLoading);

			this.el.find(".welcome-loading-hint").toggleClass("is-hidden", this.state.shouldHideLoading);
		},
		el: $("body"),
		init: function() {
			this.setState({shouldHideLoading: true});

			var welcomeBanner = new WelcomeBanner();
			welcomeBanner.init();

			var highlightsRisksFeatureSection = new HighlightsRisksFeatureSection();
			highlightsRisksFeatureSection.init();

			var mediaReports = new MediaReports();
			mediaReports.init();

			window.sr = ScrollReveal();
			sr.reveal('.welcome-banner-content', {
				duration: 2000,
				scale: 1
			});
			sr.reveal('.highlights-risks-container', {
				duration: 1500,
				scale: 0.98
			});
			sr.reveal('.custom-screeners-showcase', {
				duration: 1500,
				scale: 0.98
			});
			sr.reveal('.strategy-screeners-item', {
				duration: 1500,
				scale: 0.98
			});
		}
	}
}

/* exec after on loaded */
$(function(){
	onLoadSetting();

	var welcomeApp = new WelcomeApp();
	welcomeApp.init();

});
